import { IStateType } from "./state/IGameState";
import GameBaseState from "./state/GameBaseState";
import GameStateFree from "./state/GameStateFree";
import GameStateInQueue from "./state/GameStateInQueue";
import GameStateCanEnterGame from "./state/GameStateCanEnterGame";
import GameStateCanReturnGame from "./state/GameStateCanReturnGame";
import GameStateMissEnterGame from "./state/GameStateMissEnterGame";
import { yunpb } from "@/types/protobuf";
import Logger from "@js/logger";
import IPCCenter from "../ipc";
import { EVENTCMD } from "../events";

export default class GameStateMgr {
  private currentState!: GameBaseState;
  private currentPlayerStatus!: IStateType;
  constructor(type: IStateType) {
    this.init(type);
  }
  init(type: IStateType) {
    this.currentState = this.getState(type);
    this.currentPlayerStatus = type;
    IPCCenter.getInstance().addListener(
      EVENTCMD.SetCurrentGameState,
      (param: any) => {
        const type = param.msg as IStateType;
        Logger.log("GameStateMgr IPCCenter addListener" + type);
        // 两个tab情况下，pinia无法同步弹窗状态
        type === IStateType.FREE &&
          this.currentState.playGameStore.resetModalState();
        this.setState(type);
      }
    );
  }
  onPageReload(type: IStateType) {
    this.currentPlayerStatus = type;
    this.setState(type);
    this.currentState.onPageReload();
  }
  onStateEnter() {
    this.currentState.onStateEnter();
  }
  setState(type: IStateType) {
    this.currentState = this.getState(type);
    this.onStateEnter();
    this.setIStateType(type);
  }
  setIStateType(type: IStateType) {
    localStorage.setItem("CURRENTSTATE", type.toString());
  }
  playGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    this.currentState.playGame(game!);
  }
  exitGame() {
    this.currentState.exitGame();
  }
  reQueueGame() {
    this.currentState.reQueueGame();
  }
  getState(type: IStateType): GameBaseState {
    Logger.log("GameStateMgr getState: " + IStateType[type]);
    switch (type) {
      case IStateType.FREE:
        return new GameStateFree();
      case IStateType.IN_QUE:
        return new GameStateInQueue();
      case IStateType.CAN_ENTER_GAME:
        return new GameStateCanEnterGame();
      case IStateType.CAN_RETURN_GAME:
        return new GameStateCanReturnGame();
      case IStateType.MISS_ENTER_GAME:
        return new GameStateMissEnterGame();
      default:
        return new GameStateFree();
    }
  }
}
